exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-nav-bar-wrapper{position:relative}.dashboard-nav-bar{display:-webkit-box;display:-ms-flexbox;display:flex;position:fixed;background:#ccc;padding:1rem}", ""]);

// exports
